import React, { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Field } from 'formik'
import { Form, Spinner } from 'lib/ui/components'
import { useStoreView } from 'hooks/useStoreView'
import {
  Header,
  Actions,
  Items,
  Button,
  ContentBlock
} from './styled'
import { Question } from 'hooks/productSelector'
import { ReactComponent as ArrowLeft } from 'resources/svg/icons/arrow-left.svg'
import { ReactComponent as ArrowRight } from 'resources/svg/icons/arrow-right.svg'
import { ReactComponent as EditSvg } from 'resources/svg/icons/edit-thin.svg'
import { FormValues } from '../../../scenes/CustomerDashboard/scenes/Subscriptions/components/ProductItem/components/EditForm/schema'

interface Props {
  handleSubmit: (values: any) => void
  loading: boolean
  options: any
  title: string
  type: string
  isReviewStep: boolean
  questionId: string
  isFirstStep: boolean
  step: number
  setStep: (id: any) => void
  stepBack: (answer: any) => void
  setShowResults: (result: boolean) => void
  questions: Question[]
  saveCustomerAnswers?: () => void
}

export const ProductSelectorQuestions: React.FC<Props> = ({
  handleSubmit,
  loading,
  options,
  title,
  type,
  isReviewStep,
  questionId,
  isFirstStep,
  setStep,
  step,
  stepBack,
  setShowResults,
  questions,
  saveCustomerAnswers
}) => {
  const history = useHistory()
  const { isSofiaAndGrace, isLivBrite } = useStoreView()
  const scrollRef = useRef<HTMLDivElement>(null)
  const formValues = {}

  return (
    <Formik
      key={`step-${step}`}
      initialValues={formValues}
      onSubmit={handleSubmit}
    >
      {(formikProps: any) => {
        const { values } = formikProps
        return (
          <Form.Wrapper>
            <Form.FormikObserver<FormValues>
              autoSubmit
            />
            {loading ? (
              <Spinner />
            ) : (
              <ContentBlock
                ref={scrollRef}
                isSofia={isSofiaAndGrace}
              >
                <Header
                  isSofia={isSofiaAndGrace}
                >
                  <h3>
                    {isReviewStep ? 'Your answers' : title}
                  </h3>
                </Header>
                {options && !isReviewStep && (
                  <Items
                    isLivbrite={isLivBrite}
                  >
                    {(options as any[])?.map((option: Record<string, string>) => {
                      const { label, value, image: icon } = option
                      const labelClass = icon ? 'label' : 'label _no-icon'
                      const isNumericOption = Boolean(parseInt(label))

                      switch (type) {
                        case 'text':
                          return (
                            <label className='text' key={value}>
                              <Field
                                name={value}
                                label={label}
                                component={Form.Input}
                              />
                            </label>
                          )

                        case 'multiselect':
                          return (
                            <label className='radio' key={value}>
                              <Field type='checkbox' name={questionId} value={label} />
                              <div className='item'>
                                {icon && (
                                  <div className='icon-wrap'>
                                    <div
                                      className='icon'
                                      style={{
                                        backgroundImage: `url(${icon})`
                                      }}
                                    />
                                  </div>
                                )}
                                <div className={labelClass}>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: label
                                    }}
                                  />
                                </div>
                              </div>
                            </label>
                          )

                        default:
                          return (
                            <label className={isNumericOption ? 'radio numeric' : 'radio'} key={value}>
                              <Field
                                type='radio'
                                name={questionId}
                                value={value}
                                checked={values[questionId] === value.toString()}
                              />
                              <div className='item'>
                                {icon && (
                                  <div className='icon-wrap'>
                                    <div
                                      className='icon'
                                      style={{
                                        backgroundImage: `url(${icon})`
                                      }}
                                    />
                                  </div>
                                )}
                                <div className={labelClass}>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: label
                                    }}
                                  />
                                </div>
                              </div>
                            </label>
                          )
                      }
                    })}
                  </Items>
                )}
                {isReviewStep && (
                  <Items
                    isLivbrite={isLivBrite}
                  >
                    {questions.map((question: Record<string, any>) => {
                      const answers = question.answers?.map((answer: any) => {
                        const { label, value } = answer
                        const textQuestion = question.type === 'text'
                        return !textQuestion ? label : `${label}: ${value}`
                      }).join(', ')
                      return (
                        <div
                          className='item result'
                          key={question.id}
                          onClick={() => stepBack(question)}
                        >
                          <div className='label'>
                            <p>
                              {`${question.title}: `}
                              <strong
                                dangerouslySetInnerHTML={{
                                  __html: answers
                                }}
                              />
                            </p>
                          </div>
                          <div className='icon-wrap'>
                            <EditSvg />
                          </div>
                        </div>
                      )
                    })}
                  </Items>
                )}
                <Actions>
                  {isReviewStep && (
                    <div className='submit-wrap'>
                      <Button
                        className='btn'
                        isLivbrite={isLivBrite}
                        onClick={saveCustomerAnswers}
                      >
                        Show My Perfect Product
                      </Button>
                    </div>
                  )}
                  <div className='nav-wrap'>

                    {!isFirstStep && !isReviewStep && (
                      <div>
                        <Button className='link' type='button' onClick={() => stepBack(questions[step-1])}>
                          <ArrowLeft />
                          <span>Back</span>
                        </Button>
                      </div>
                    )}

                    {isReviewStep && (
                      <div>
                        <Button className='link' type='button' onClick={() => history.push('/')}>
                          <span>Shop All Products</span>
                          <ArrowRight />
                        </Button>
                      </div>
                    )}
                  </div>
                </Actions>
              </ContentBlock>
            )}
          </Form.Wrapper>
        )
      }}
    </Formik>
  )
}
